import { render, staticRenderFns } from "./codeset.vue?vue&type=template&id=7970d5ef"
import script from "./codeset.vue?vue&type=script&lang=js"
export * from "./codeset.vue?vue&type=script&lang=js"
import style0 from "./codeset.vue?vue&type=style&index=0&id=7970d5ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports